
<div class="logo">
  <img src="assets/logo.png">
</div>

<div class="center">
  <mat-card class="form">
    <form class="example-form" [formGroup]="loginForm">
      <mat-form-field class="example-full-width">
        <mat-label>Email Adresse</mat-label>
        <input matInput type="email" formControlName="email" class="form-control" placeholder="xyz@iubh-fernstudium.de">
      </mat-form-field>

      <mat-form-field class="example-full-width">
        <mat-label>Passwort</mat-label>
        <input matInput type="password" class="form-control" formControlName="password">
      </mat-form-field>
      <div class="center">
        <button mat-stroked-button type="submit" (click)="tryLogin(loginForm.value)" class="btn btn-default button">LOGIN</button>
      </div>
      <br /><mat-label class="error">{{errorMessage}}</mat-label>
    </form>
  </mat-card>
</div>

<div class="row center">
  <div>Noch nicht angemeldet? <a href="/register" class="pointer">Zugang erstellen</a></div>
</div>

<div class="row center pointer">
  <div><a (click)="tryReset()">Probleme beim Login?</a></div>
</div>







